'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHdrOn = function MdHdrOn(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 22.5v-5h-3.2v5h3.2z m0-7.5c1.4 0 2.5 1.2 2.5 2.5v5c0 1.3-1.1 2.5-2.5 2.5h-5.7v-10h5.7z m-10.7 3.4v-3.4h2.5v10h-2.5v-4.1h-3.4v4.1h-2.5v-10h2.5v3.4h3.4z m21.6 0.7v-1.6h-3.4v1.6h3.4z m2.5 0c0 1.1-0.6 1.9-1.5 2.4l1.5 3.5h-2.5l-1.5-3.4h-1.9v3.4h-2.5v-10h5.9c1.3 0 2.5 1.2 2.5 2.5v1.6z' })
        )
    );
};

exports.default = MdHdrOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/hdr-on.js
// module id = 3410
// module chunks = 168707334958949